// extracted by extract-css-chunks-webpack-plugin
module.exports = {"detail":"detail_29MoN","content":"content_3JZd7","title":"title_3on9a","article":"article_1As0X","page":"page_342NT"};